import { AnimatePresence, motion } from 'framer-motion';
import { Gift, Headphones } from 'lucide-react';
import { birthdayConfig } from '../config';
import { Sticker } from '../components/Sticker';
import { useBirthdayAudio } from '../hooks/useBirthdayAudio';

type Props = {
  open: boolean;
  onOpen: () => void;
};

export function OpeningOverlay({ open, onOpen }: Props) {
  const { startMusic } = useBirthdayAudio();

  const begin = async () => {
    await startMusic();
    onOpen();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="opening-overlay"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.08, filter: 'blur(12px)' }}
          transition={{ duration: 0.8 }}
        >
          <div className="opening-orb opening-orb-one" />
          <div className="opening-orb opening-orb-two" />
          <motion.div
            className="opening-card glass"
            initial={{ opacity: 0, y: 30, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ type: 'spring', stiffness: 130, damping: 16 }}
          >
            <motion.div
              className="gift-box"
              animate={{ y: [0, -8, 0], rotate: [0, -2, 2, 0] }}
              transition={{ repeat: Infinity, duration: 2.8, ease: 'easeInOut' }}
            >
              <Gift size={72} strokeWidth={1.5} />
              <span className="gift-glow" />
            </motion.div>
            <Sticker
              src="/stickers/mochi-celebrate.svg"
              alt="Mochi cat celebrating"
              className="opening-sticker"
            />
            <span className="eyebrow">Made with love</span>
            <h1>{birthdayConfig.opening.title}</h1>
            <p><Headphones size={18} /> {birthdayConfig.opening.subtitle}</p>
            <motion.button className="primary-button opening-button" onClick={() => void begin()} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
              {birthdayConfig.opening.buttonLabel}
            </motion.button>
            <small>Music starts only after your tap. You can mute it anytime.</small>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
